import { useEffect, useMemo, useState } from 'react';
import { Tab } from 'react-bootstrap';
import UserList from './UserList';
import { ConversationFilterType, useChatContext } from 'providers/ChatProvider';
import { Conversation } from 'data/chat';
import PhoenixNav from 'components/base/PhoenixNav';

interface ChatFilterTabProps {
  searchQuery: string;
}

const ChatFilterTab = ({ searchQuery }: ChatFilterTabProps) => {
  const { conversations } = useChatContext();
  const [activeTab, setActiveTab] = useState<ConversationFilterType>('pendientes');
  const [filteredConversations, setFilteredConversations] = useState<Conversation[]>([]);

  // Lógica de filtrado unificada
  const filterConversations = () => {
    const filtered = conversations.filter(conversation => {
      // 1. Lógica de búsqueda por nombre
      const userName = (conversation.user.name || '').toLowerCase();
      const matchesSearch = userName.includes(searchQuery.toLowerCase());

      // 2. Lógica de pestañas (Leídos/No leídos)
      const hasUnreadMessages = (conversation.messages ?? []).some(
        message => message.type === 'received' && !message.readAt
      );

      // Adentro de filterConversations() en ChatFilterTab.tsx:
  const estadoConversacion = conversation.estado || 'Pendiente';

  let matchesTab = true;
  if (activeTab === 'pendientes') matchesTab = estadoConversacion === 'Pendiente';
  if (activeTab === 'resueltas') matchesTab = estadoConversacion === 'Resuelta';

      // Debe cumplir AMBAS condiciones
      return matchesSearch && matchesTab;
    });

    setFilteredConversations(filtered);
  };

  // Ítems de navegación (Pestañas)
  const filterItems = useMemo(
    () => [
      {
        label: 'Pendientes',
        eventKey: 'pendientes',
        onClick() {
          setActiveTab('pendientes');
        }
      },
      {
        label: 'Resueltas',
        eventKey: 'resueltas',
        onClick() {
          setActiveTab('resueltas');
        }
      },
      {
        label: 'Todos',
        eventKey: 'all',
        onClick() {
          setActiveTab('all');
        }
      }
    ],
    []
  );

  // Ejecutar el filtro cada vez que cambien las conversaciones, 
  // la pestaña activa o lo que el usuario escribe en el buscador
  useEffect(() => {
    filterConversations();
  }, [conversations, activeTab, searchQuery]);

  return (
    <Tab.Container defaultActiveKey="pendientes" activeKey={activeTab}>
      <PhoenixNav navItems={filterItems} />
      <UserList conversations={filteredConversations} />
    </Tab.Container>
  );
};

export default ChatFilterTab;